import { SecuredPaymentClient } from '../../../Core/Api/Payment/SecuredPaymentClient';
import {
  ConfirmCreditCardRegistrationRequestBody,
  AddressDto,
  ReferenceValueDto,
  IReferenceValueDto,
  ExecuteBillOfLadingPaymentRequest,
  BillOfLadingPaymentResponse,
  CompleteThreeDSecureBolPaymentRequest,
} from '../../../Core/Api/Payment/Api';
import ConfigUtility from 'Core/ConfigUtility';
import TokenUtility from 'Core/TokenUtility';

export default class ThreeDSecureHandler {
  props: any;
  constructor(props) {
    this.props = props;
  }

  CheckIfPaymentCompleted(request: CompleteThreeDSecureBolPaymentRequest) {
    const client = new SecuredPaymentClient();
    client.DisableToken = true;
    client.showLoading = false;
    client.DisableToken = false;
    client.showLoading = false;

    const authorization = TokenUtility.GetUMAToken();
    return client.threeDSecure(authorization, request as any).catch(x => {
      console.log('structure returned', JSON.stringify(x));
      if (x.response && x.response.data && x.response.data.errorCode) {
        return x.response.data as BillOfLadingPaymentResponse;
      } else {
        throw Error(
          `Something when wrong with payment process.
Please to not attempt to pay again until you have contacted customer service.`
        );
      }
    });
  }
}
